module.exports = __webpack_public_path__ + "static/media/landing.5a5f89d3.svg";